const GEO_URL = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_URL = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

let geoCache = null;

export async function getGeoLocation() {
  if (geoCache) return geoCache;
  try {
    const res = await fetch(GEO_URL, { headers: { accept: 'text/plain' } });
    const data = await res.json();
    if (data.isSuccess) {
      geoCache = data;
      return data;
    }
  } catch (err) {
    console.error('GeoLocation error:', err);
  }
  return null;
}

export async function submitLead({ name, email, countryDialCode, country, phoneNumber, description, packageTitle, packageAmount, geoData }) {
  if (!geoData) {
    geoData = await getGeoLocation();
  }

  const payload = {
    name,
    email,
    countryDialCode: parseInt(String(countryDialCode).replace('+', ''), 10) || 1,
    country: country || 'US',
    phoneNumber: phoneNumber.replace(/[^0-9]/g, ''),
    ipAddress: geoData?.data?.ipAddress || '',
    description: description || '',
    pageUrl: window.location.href,
    city: geoData?.data?.cityName || '',
    state: geoData?.data?.regionName || '',
    geoLocation: geoData ? JSON.stringify(geoData) : '',
    packageTitle: packageTitle || '',
    packageAmount: packageAmount || 0,
  };

  try {
    const res = await fetch(LEAD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    let json;
    try {
      json = await res.json();
    } catch {
      return { success: false, error: 'Invalid response from server' };
    }

    if (json.statusCode === 200 && json.isSuccess && json.data?.customerId) {
      return { success: true, customerId: json.data.customerId };
    }

    if (json.statusCode === 401) {
      return { success: false, error: json.message || 'Unauthorized request' };
    }

    if (json.statusCode === 400) {
      return { success: false, error: json.errorMessage || json.data?.message || 'Invalid request' };
    }

    if (json.errors) {
      const firstError = Object.values(json.errors)[0];
      return { success: false, error: Array.isArray(firstError) ? firstError[0] : firstError };
    }

    return { success: false, error: json.errorMessage || json.message || 'Something went wrong' };
  } catch (err) {
    console.error('Lead API error:', err);
    return { success: false, error: 'Network error. Please try again.' };
  }
}
